<template>
  <div id="per_center">
    <!-- 深色舞台头图横幅（静态装饰，匹配 youxuan-content.html .cbanner） -->
    <section class="cbanner">
      <div class="bg"></div>
      <div class="grid-lines"></div>
      <div class="eyebrow">TRADE PROTECTION</div>
      <h1>交易<em>保障</em></h1>
      <div class="en">Escrow · Recovery Compensation · Capital Safety · E-Contract</div>
      <span class="gno">100%</span>
    </section>
    <div class="center_body">
    <div class="nav_menu">
      <div class="nav_menu_title">
        <div class="nav_menu_title_img">
          <img src="@/assets/image/Legal/legalLogo.png" alt="">
        </div>
        <div class="nav_menu_title_text">交易保障</div>
        <div><i class="el-icon-arrow-down"></i></div>
      </div>
      <div class="nav_menu_content">
        <el-menu
          router
          :default-active="defaultActive"
          :unique-opened="true"
          class="nav_menu-list"
          @select="handleSelect"
          @open="handleOpen"
          @close="handleClose">
          <!-- 交易流程 -->
          <el-menu-item v-for="item in menu" :key="item.id" :index="item.id.toString()"
                        :route="{name:'Legal',query:{id:item.id,parent_id:item.parent_id}}">
            <span slot="title">{{item.page_name}}</span>
            <div></div>
          </el-menu-item>
          <!-- 交易须知 -->
          <el-submenu v-for="item in submenu" :key="item.id" :index="item.id.toString()">
            <template slot="title">
              <span> {{ item.page_name }}</span>
              <div></div>
            </template>
            <el-menu-item :index="childItem.id.toString()" v-for="childItem in item._child" :key="childItem.id"
                          :route="{name:'Legal',query:{id:childItem.id,parent_id:item.parent_id}}">
              <div></div>
              {{ childItem.page_name }}
            </el-menu-item>
          </el-submenu>

        </el-menu>
      </div>
    </div>
    <div class="main">
      <!--   售后服务   -->
      <after-sale v-if="ref == 105"></after-sale>
      <!--   追回案例   -->
      <cases v-else-if="ref == 113" ></cases>

      <Content :key1='ref' v-else></Content>
      <!--      <router-view></router-view>-->
    </div>
    </div>
  </div>

</template>

<script>
import AfterSale from "../TradeTip/afterSale";
import Content from './content'
import Cases from './cases'
import {apiNavPage} from "@/request/API";

export default {
  name: '',
  props: {
  },
  components: {
    Content,
    AfterSale,
    Cases
  },
  data () {
    return {
      ref:this.$route.query.id.toString(),
      parent_id:this.$route.query.parent_id,
      menu:[],
      submenu:[]
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.ref=key.toString()
    },
    handleOpen(key, keyPath) {

    },
    handleClose(key, keyPath) {
    },
    getNavPage(){
      apiNavPage({
        id:this.$route.query.parent_id
      }).then(res=>{
        res.data.forEach((item,index)=>{
          if ('_child' in item) {
            this.submenu.push(item)
          }else{
            this.menu.push(item)
          }
        })
      })
    }
  },
  mounted () {
    this.getNavPage()
  },
  watch: {

  },
  computed: {
    defaultActive(){
      this.submenu.forEach((item,index)=>{
        if (this.$route.query.id == item.id) {
          return item._child[0].id.toString()
        }
      })
      return this.$route.query.id.toString()
    }
  },
  created() {
  },
  beforeRouteUpdate(to,from,next){
    this.ref = to.query.id.toString()
    next()
  }
}
</script>

<style lang='less' scoped>
#per_center{
  width: 1200px;
  margin-top: 14px;
  margin-bottom: 0;
  min-height: 680px;
  min-height: max(680px, calc(100vh - 430px));
  display: flex;
  flex-direction: column;
  align-items: stretch;
  /* 深色舞台头图横幅 */
  .cbanner {
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    background: var(--bg-stage, #0E1116);
    padding: 38px 40px;
    margin-bottom: 18px;
    .bg {
      position: absolute;
      inset: 0;
      background:
        radial-gradient(120% 90% at 82% 8%, rgba(255, 90, 31, .20), transparent 55%),
        linear-gradient(115deg, #171b22 0%, #0e1116 60%, #1d1410 100%);
    }
    .grid-lines {
      position: absolute;
      inset: 0;
      background-image:
        linear-gradient(rgba(255, 255, 255, .03) 1px, transparent 1px),
        linear-gradient(90deg, rgba(255, 255, 255, .03) 1px, transparent 1px);
      background-size: 40px 40px;
      mask-image: linear-gradient(180deg, transparent, #000 70%);
      -webkit-mask-image: linear-gradient(180deg, transparent, #000 70%);
    }
    .eyebrow {
      position: relative;
      font-size: 11px;
      letter-spacing: 2px;
      color: var(--primary, #FF5A1F);
      font-weight: 700;
      margin-bottom: 10px;
    }
    h1 {
      position: relative;
      color: #fff;
      font-size: 32px;
      font-weight: 900;
      letter-spacing: -1px;
      line-height: 1.1;
      margin: 0;
      em {
        font-style: normal;
        color: var(--primary, #FF5A1F);
      }
    }
    .en {
      position: relative;
      color: #8b919c;
      font-size: 13px;
      margin-top: 10px;
      letter-spacing: 1px;
    }
    .gno {
      position: absolute;
      right: 26px;
      bottom: -22px;
      font-style: italic;
      font-weight: 900;
      font-size: 120px;
      color: rgba(255, 255, 255, .05);
      line-height: 1;
    }
  }
  /* 两栏正文区 */
  .center_body {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 12px;
  }
  .nav_menu{
    width: 243px;
    flex: 0 0 243px;
    position: sticky;
    top: 14px;
    align-self: flex-start;
    margin-right: 0;
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    overflow: hidden;
    box-sizing: border-box;
    .nav_menu_title{
      height: 72px;
      background: var(--bg-dark, #1A1D24);
      border-radius: 4px 4px 0px 0px;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 20px 0 26px;
      .nav_menu_title_img{
        width: 38px;
        height: 38px;
        margin-right: 10px;
        padding: 7px;
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.18);
        box-sizing: border-box;
        img{
          width: 100%;
          height: 100%;
          object-fit: contain;
          display: block;
        }
      }
      .nav_menu_title_text{
        flex: 1;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        margin-right: 0;
      }
      .el-icon-arrow-down{
        color: rgba(255, 255, 255, 0.82);
        font-size: 14px;
      }
    }
    .nav_menu_content{
      min-height: calc(100% - 72px);
      padding: 12px 10px 16px 10px;
      background: var(--bg-card, #FFFFFF);
      border-radius: 0px 0px 4px 4px;
      box-sizing: border-box;
      .nav_menu-list{
        border-right: none;
        background: transparent;
      }
      .nav_menu-list>.el-menu-item {
        height: 42px;
        line-height: 42px;
        padding-left: 44px !important;
        margin-bottom: 4px;
        position: relative;
        overflow: hidden;
        border-radius: 4px;
        font-size: 15px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
        background: transparent;
        transition: color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
        div {
          display: inline-block;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: var(--border-strong, #CBD5E1);
          position: absolute;
          top: 18px;
          left: 22px;
        }
      }
      .nav_menu-list>.is-active{
        color: #FFFFFF !important;
        background: var(--bg-dark, #1A1D24);
        box-shadow: none;
        transform: skewX(-12deg);
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 7px;
          height: 7px;
          background: var(--primary, #FF5A1F);
          clip-path: polygon(0 0, 100% 0, 0 100%);
        }
        span{
          display: inline-block;
          transform: skewX(12deg);
        }
        div{
          background: var(--primary, #FF5A1F);
          transform: skewX(12deg);
        }
      }
      .nav_menu-list>.el-menu-item:hover{
        color: var(--text-main, #1A1D24) !important;
        background: var(--bg-tag, #F0EDE8);
        box-shadow: none;
        div{
          background: var(--primary, #FF5A1F);
        }
      }
      .nav_menu-list>.is-active:hover{
        color: #FFFFFF !important;
        background: var(--bg-dark, #1A1D24);
        div{
          background: var(--primary, #FF5A1F);
        }
      }
      /deep/.el-menu-item, /deep/.el-submenu__title{
        height: 42px;
        line-height: 42px;
        padding-left: 44px !important;
        border-radius: 4px;
        font-size: 15px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
        background: transparent;
        transition: color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
      }
      /deep/.is-active>.el-submenu__title{
        color: var(--text-main, #1A1D24) !important;
        background: var(--bg-tag, #F0EDE8);
        box-shadow: none;
        div{
          background: var(--primary, #FF5A1F) !important;
        }
      }
      /deep/.el-submenu__title:hover,.el-submenu__title:focus{
        color: var(--text-main, #1A1D24);
        background: var(--bg-tag, #F0EDE8);
        div{
          background: var(--primary, #FF5A1F) !important;
        }
      }
      /deep/.el-submenu>.el-submenu__title{
        margin-bottom: 4px;
        div{
          display: inline-block;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: var(--border-strong, #CBD5E1);
          position: absolute;
          top: 18px;
          left: 22px;
        }
      }
      /deep/.el-menu--inline{
        margin: 0 0 6px 0;
        padding: 6px 0;
        border-radius: 4px;
        background: var(--bg-section, #F7F5F2);
      }
      /deep/.el-menu--inline>.el-menu-item{
        height: 38px;
        line-height: 38px;
        margin: 0 6px 4px 6px;
        padding-left: 38px !important;
        border-radius: 4px;
        font-size: 14px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 400;
        color: var(--text-muted, #9AA0AC);
      }
      /deep/.el-menu--inline>.el-menu-item:hover{
        color: var(--text-main, #1A1D24);
        background: var(--bg-tag, #F0EDE8);
        position: relative;
        div{
          position: absolute;
          width: 2px;
          height: 16px;
          background: var(--primary, #FF5A1F);
          border-radius: 1px;
          top: 11px;
          left: 22px;
        }
      }
      /deep/.el-submenu>.el-menu--inline>.is-active{
        color: #FFFFFF !important;
        background: var(--bg-dark, #1A1D24);
        position: relative;
        overflow: hidden;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 7px;
          height: 7px;
          background: var(--primary, #FF5A1F);
          clip-path: polygon(0 0, 100% 0, 0 100%);
        }
        div{
          position: absolute;
          width: 2px;
          height: 16px;
          background: var(--primary, #FF5A1F);
          border-radius: 1px;
          top: 11px;
          left: 22px;
        }
      }
      /*菜单关闭*/
      /deep/.el-submenu>.el-submenu__title .el-submenu__icon-arrow{
        -webkit-transform: rotateZ(-90deg);
        -ms-transform: rotate(-90deg);
        transform: rotateZ(-90deg);
      }
      /*菜单展开*/
      /deep/.el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow{
        -webkit-transform: rotateZ(0deg);
        -ms-transform: rotate(0deg);
        transform: rotateZ(0deg);
      }
    }
  }
  .main{
    width: 945px;
    min-height: 680px;
    min-height: max(680px, calc(100vh - 430px));
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    overflow: hidden;
    box-sizing: border-box;
  }
}
</style>
